module.exports = __webpack_public_path__ + "static/media/notification-new.b08ef109.svg";